import React, { useState } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { ExercisePopup } from './ExercisePopup';
import { useExercise } from './hooks/useExercise';
import ZeroState from '../common/ZeroState';
import FileIcon from '../../assets/EmptyFolder';
import ConfirmationDialog from '../common/ConfirmationDialog';
import DeleteIcon from '../../assets/DeleteIcon';
import CustomCard from '../shared/CustomCard';
import { AI_EXERCISE_MENU_ITEMS } from './contants';
import { setSelectedExercise } from '../../redux/actions/DealershipActions';

const useStyle = makeStyles({
  add: {
    width: '40px',
    height: '40px',
    color: 'white',
    background: '#622FEE',
    border: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    cursor: 'pointer',
  },
  moreIcon: {
    height: '20px',
    cursor: 'pointer',
  },
});

export const AIMainContent = () => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const { isOpenPopup, setIsOpenPopup, deleteExercise } = useExercise();

  const { exercise } = useSelector((state) => state.aiRoleplayData);
  const selectedCat = useSelector((state) => state.aiRoleplayData.selectedCategory || {});

  const handleDelete = async () => {
    deleteExercise();
    setIsConfirmDelete(false);
  };

  const handleCreateOpen = () => {
    setIsEdit(false);
    setIsOpenPopup(true);
  };

  const handleMenuItemClick = async (e, name) => {
    const clickedId = e.currentTarget.getAttribute('data-id');
    const selected = exercise?.levels?.flatMap((level) => level?.exercises || []).find((ex) => ex.id === clickedId);
    dispatch(setSelectedExercise(selected));
    if (name === 'Edit Exercise') {
      setIsEdit(true);
      setIsOpenPopup(true);
    } else if (name === 'Delete Exercise') {
      setIsConfirmDelete(true);
    }
  };

  return (
    <Grid container direction="row">
      <Grid item xs={12}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          style={{ height: '50px', background: '#f3f4f7', padding: '0px 15px' }}
        >
          <Typography variant="h6">Exercise</Typography>
          <Grid className={classes.add} onClick={handleCreateOpen}>
            <Add />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          {selectedCat?.exerciseCount ? (
            <Grid item xs={12} style={{ height: '65vh', overflowY: 'auto' }}>
              {exercise?.levels?.map((level) => (
                <Grid container style={{ gap: '10px', marginTop: '25px' }} key={level.level}>
                  <Grid item xs={12}>
                    <Typography style={{ fontSize: '16px', fontWeight: '600' }}>{level.level}</Typography>
                  </Grid>
                  {level.unlockScore !== null ? (
                    <Grid item xs={12}>
                      <Typography style={{ fontSize: '14px', fontWeight: '500', color: '#667085' }}>
                        {`Unlock Score - ${level.unlockScore}%`}
                      </Typography>
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    <Grid container style={{ flexWrap: 'wrap', gap: '20px' }}>
                      {level?.exercises?.map((item) => (
                        <CustomCard
                          name="ai_exercise"
                          height="70px"
                          width="400px"
                          key={item.id}
                          id={item.id}
                          thumbnail={item.thumbnail}
                          title={item.name}
                          subTitle={`AI Exercise ID: ${item.id}`}
                          grey
                          menu
                          menuItems={AI_EXERCISE_MENU_ITEMS}
                          handleMenuItemClick={handleMenuItemClick}
                        />
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid item xs={12} style={{ height: '65vh', overflowY: 'auto' }}>
              <ZeroState
                Icon={FileIcon}
                title="No Exercises Found"
                text="Add your first exercise now."
                style={{ paddingBottom: '100px', marginTop: '40px' }}
                cardWidth="600px"
                btnText="Add Exercise"
                btnAction={handleCreateOpen}
              />
            </Grid>
          )}
        </Grid>
      </Grid>

      <ConfirmationDialog
        title="Are you sure you want to delete the exercise category?"
        subText="Once you delete it, you will not be able to recover it."
        onClose={setIsConfirmDelete}
        isOpen={isConfirmDelete}
        confirmFn={handleDelete}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="500px"
        height="260px"
      />

      {isOpenPopup && <ExercisePopup isOpen={isOpenPopup} setIsOpen={setIsOpenPopup} isEdit={isEdit} />}
    </Grid>
  );
};
